//Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  model,
  OnDestroy,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule, NgIf } from '@angular/common';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';

//Angular Material
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';

//Librerias externas
import {
  Observable,
  of,
  zip,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  catchError,
  map,
  filter,
} from 'rxjs';

//Componentes
import { BuscardorDireccionService } from '../../../../shared/services/buscardor-direccion.service';
import { HeaderSophiaComponent } from '../header-sophia/header-sophia.component';
import { IntlTelInputComponent } from '../../../../shared/components/input-telephone/input-telephone.component';
import { ModalConfirmCambioDatosComponent } from '../../../../shared/components/modal-confirm-cambio-datos/modal-confirm-cambio-datos.component';

//Interfaces
import { IDataDireccion } from '../../../../shared/interfaces/buscar-direccion.interface';
import { IDataDocumento } from '../../../../shared/interfaces/tipo-documento.interface';
import { IDataPacienteForm } from '../../../../shared/interfaces/paciente-form.interface';
import { IDataSeguro } from '../../../../shared/interfaces/seguros.interface';
import { AppPermissions, StorageKeys, StorageType } from '../../../../shared/enums';

//Services
import { IdDireccionSeleccionadaSignalService } from '../../../../shared/services/id-direccion-seleccionada-signal.service';
import { ObtenerInstitucionesService } from '../../../../shared/services/obtener-instituciones.service';
import { ObtenerPrevisionService } from '../../../../shared/services/obtener-prevision.service';
import { ObtenerTipoDocumentoService } from '../../../../shared/services/obtener-tipo-documento.service';
import { ShareDataService } from '../../../../shared/services/share-data.service';
import { UtilServiceService } from '../../../../shared/services/util-service.service';
import { AgendamientosService } from '../../../services/agendamientos.service';
import { IDataAgendamientoById } from '../../../../shared/interfaces/agendamientos.interface';
import { HasAccessDirective } from '../../../../shared/directives/has-access/has-access.directive';
import { TIPOS_ATENCION } from '../../../../shared/constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  SnackInfoComponent,
  SnackInfoProps,
  SnackInfoType,
} from '../../../../shared/components/snack-info/snack-info.component';
import {
  FileUploadComponent,
  UploadedLocalFile,
} from '../../../../shared/components/file-upload/file-upload.component';
import { StorageService } from '@shared/services/index';
import { CentroMedico, Medicos } from '@shared/interfaces/perfil.interface';

@Component({
  selector: 'soph-ingreso-nueva-consulta',
  standalone: true,
  imports: [
    CommonModule,
    HeaderSophiaComponent,
    IntlTelInputComponent,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    NgIf,
    ReactiveFormsModule,
    HasAccessDirective,
    FileUploadComponent,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './ingreso-nueva-consulta.component.html',
  styleUrl: './ingreso-nueva-consulta.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IngresoNuevaConsultaComponent implements OnInit, OnDestroy {
  private readonly storage = inject(StorageService);

  consultaForm: FormGroup;
  formularioHora = false;
  selected = model<Date | null>(null);
  times: string[] = [];
  horaInicio: string | null = null;

  previsiones: any;
  tipoConsultaOptions: { value: string; name: string }[] = [];
  tipoPrevisionOptions: IDataSeguro[] = [];
  tipoDocumentoOptions: IDataDocumento[] = [];
  dataExistePaciente: any;
  filterDireccion!: Observable<string[]>;
  filterers!: string[];
  listDirecciones: IDataDireccion[] = [];
  filteredOptionsEmptyDireccion: boolean = false;
  telephonePrefix: string = '';
  idDireccionSeleccionada: any;
  addresDireccionSeleccionada: any;

  // Definir la señal
  idDirecSeleccionada = signal<string | null>(null);

  // Método para actualizar la señal
  actualizarDireccionSeleccionada(id: string | null) {
    this.idDireccionSeleccionada.set(id);
  }

  /*FLAGS VISUALIZACION DE CAMPOS*/
  public showCamposDni = false;
  public showCamposPassport = false;
  public showCamposOtros = false;
  public showCamposDomicilio = false;
  public showCampoTelMed = false;
  public showDireccionManual = false;

  idNumeroDocumento: any;
  /*GETTERS CAMPOS FORM*/
  get tipoDocumento(): FormControl {
    return this.consultaForm.get('tipoDocumento') as FormControl;
  }
  get numeroDocumento(): FormControl {
    return this.consultaForm.get('numeroDocumento') as FormControl;
  }
  get numeroPasaporte(): FormControl {
    return this.consultaForm.get('numeroPasaporte') as FormControl;
  }
  get numeroDocumentoOtros(): FormControl {
    return this.consultaForm.get('numeroDocumentoOtros') as FormControl;
  }
  get nombre(): FormControl {
    return this.consultaForm.get('nombre') as FormControl;
  }
  get apellidos(): FormControl {
    return this.consultaForm.get('apellidos') as FormControl;
  }
  get email(): FormControl {
    return this.consultaForm.get('email') as FormControl;
  }
  get numero(): FormControl {
    return this.consultaForm.get('numero') as FormControl;
  }
  get prevision(): FormControl {
    return this.consultaForm.get('prevision') as FormControl;
  }
  get tipoAtencion(): FormControl {
    return this.consultaForm.get('tipoAtencion') as FormControl;
  }
  get link(): FormControl {
    return this.consultaForm.get('link') as FormControl;
  }
  get direccion(): FormControl {
    return this.consultaForm.get('direccion') as FormControl;
  }
  get casaDepto(): FormControl {
    return this.consultaForm.get('casaDepto') as FormControl;
  }
  get direccionCompleta(): FormControl {
    return this.consultaForm.get('direccionCompleta') as FormControl;
  }

  pasaporteId: string = '';
  dniId: string = '';
  otrosId: string = '';

  formDataRegistroPaciente: IDataPacienteForm = {} as IDataPacienteForm;

  subs: Subscription = new Subscription();
  flagDirecciones = false;
  signalDireccion: WritableSignal<string | null> = signal<string | null>(null);
  direccionCompletaValue: string | null = null;
  idAgendamientoToUpdate: WritableSignal<string | null> = signal<string | null>(null);
  agendamientoExistente: IDataAgendamientoById | null = null;
  fromEdit: boolean = false;
  prueba: boolean = false;
  dateSelected: Date | null = null;
  private lastProcessedAddress = '';

  private readonly formatoEmail = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  protected readonly AppPermissions = AppPermissions;

  private readonly snackBar = inject(MatSnackBar);

  protected readonly archivosPaciente: FormControl<Array<UploadedLocalFile> | null> =
    new FormControl([]);
  protected readonly NoExistePaciente: WritableSignal<boolean> = signal<boolean>(false);

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private dialog: MatDialog,
    private _agendamientosService: AgendamientosService,
    private obtenerPrevisionService: ObtenerPrevisionService,
    private obtenerTipoDocumentoService: ObtenerTipoDocumentoService,
    private obtenerInstitucionesService: ObtenerInstitucionesService,
    private buscarDireccionService: BuscardorDireccionService,
    private IdDireccionSignal: IdDireccionSeleccionadaSignalService,
    private shareDataService: ShareDataService,
    private utilServiceService: UtilServiceService,
    private readonly activatedRoute: ActivatedRoute,
    private route: ActivatedRoute
  ) {
    this.consultaForm = this.fb.group({
      tipoDocumento: ['', Validators.required],
      numeroDocumento: [''],
      numeroPasaporte: [''],
      numeroDocumentoOtros: [''],
      nombre: ['', Validators.required],
      apellidos: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(this.formatoEmail)]],
      numero: new FormControl('', [Validators.required]),
      prevision: ['', Validators.required],
      tipoAtencion: ['', Validators.required],
      link: [''],
      direccion: [''],
      direccionCompleta: [''],
      casaDepto: [''],
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.cargaDeServicios();
    this.initAddressFilter();
    this.setTipoAtencion();
    this.setFechaHoraSeleccionada();
    this.cdr.detectChanges();
  }

  setTipoAtencion() {
    const currentDoctor = this.storage.getItem<Medicos>(
      StorageKeys.CURRENT_DOCTOR,
      StorageType.LOCAL
    );
    const atenciones = currentDoctor?.atencionesMedicos || [];

    this.tipoConsultaOptions = TIPOS_ATENCION.filter((tipo) =>
      atenciones.some((a: any) => a.tipoAtencion === tipo.name)
    );
  }

  private setFechaHoraSeleccionada() {
    this.route.queryParams.subscribe((params) => {
      const fechaStr = params['fecha'];
      if (fechaStr) {
        this.dateSelected = new Date(fechaStr);
      }
    });
  }

  /*SERVICES*/
  private async cargaDeServicios(): Promise<void> {
    const sub = zip(
      this.obtenerPrevisionService.getPrevision(),
      this.obtenerTipoDocumentoService.getTipoDocumento()
    ).subscribe({
      next: ([previsiones, tipoDocumentos]) => {
        this.tipoPrevisionOptions = previsiones;

        this.tipoDocumentoOptions = tipoDocumentos;
        this.pasaporteId =
          this.tipoDocumentoOptions.find((doc) => doc.nombre === 'Pasaporte')?.idTipoDocumento ||
          '';
        this.dniId =
          this.tipoDocumentoOptions.find((doc) => doc.nombre === 'DNI')?.idTipoDocumento || '';
        this.otrosId =
          this.tipoDocumentoOptions.find((doc) => doc.nombre === 'Otro')?.idTipoDocumento || '';

        this.getFormDataExistente();
      },
    });

    const { idAgendamiento } = this.activatedRoute.snapshot.params;
    if (idAgendamiento) {
      this._agendamientosService.getAgendamientoById(idAgendamiento).subscribe({
        next: (resp) => {
          if (!resp.data) return;

          this.idAgendamientoToUpdate.set(idAgendamiento);
          this.agendamientoExistente = resp.data;
          this.setDataEdicionAgendamiento(resp.data);
        },
      });
    }
    this.subs.add(sub);
  }

  private initAddressFilter(): void {
    const addressSub = this.consultaForm
      .get('direccion')!
      .valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        map((valor) => (typeof valor === 'string' ? valor.toLowerCase() : '')),
        filter((valor) => {
          if (!valor) {
            this.cleanAddressResults();
            return false;
          }

          if (valor === this.lastProcessedAddress) return false;

          this.lastProcessedAddress = valor;
          return true;
        }),
        switchMap((valor) =>
          this.buscarDireccionService.getDirecciones(valor).pipe(
            catchError((error) => {
              this.handleError(error, valor);
              return of({ data: [] });
            })
          )
        )
      )
      .subscribe((resp) => this.processAddressResults(resp));

    this.subs.add(addressSub);
  }

  private cleanAddressResults(): void {
    this.filterDireccion = of([]);
    this.filteredOptionsEmptyDireccion = true;
    this.showDireccionManual = false;
  }

  private handleError(error: any, valor: string): void {
    const serverError = error?.error;
    if (serverError?.statusCode === 500 && serverError?.code === 'error/unknown') {
      this.direccionCompletaValue = valor;
    }
  }

  private processAddressResults(resp: any): void {
    this.listDirecciones = resp.data || [];

    const value: string | null | undefined = this.consultaForm.get('direccion')?.value;
    const filterValue: string = typeof value === 'string' ? value.toLowerCase() : '';

    const matches: IDataDireccion[] = this.listDirecciones.filter((d) =>
      d.address.toLowerCase().includes(filterValue)
    );

    this.filterDireccion = of(matches.map((d) => d.address));
    this.filteredOptionsEmptyDireccion = matches.length === 0;
    this.showDireccionManual = false;

    if (!matches.length && value) {
      this.direccionCompletaValue = value;
    }

    this.cdr.detectChanges();
  }

  setDataEdicionAgendamiento(agendamientoExistente: IDataAgendamientoById) {
    this.tipoDocumento.setValue(agendamientoExistente.paciente.idTipoDocumento);
    this.tipoDocumento.disable();

    this.showCampoNumeroDocumento(agendamientoExistente.paciente.idTipoDocumento);
    switch (agendamientoExistente.paciente.idTipoDocumento) {
      case this.dniId:
        this.numeroDocumento.setValue(agendamientoExistente.paciente.numeroDocumento);
        this.numeroDocumento.disable();
        break;
      case this.pasaporteId:
        this.numeroPasaporte.setValue(agendamientoExistente.paciente.numeroDocumento);
        this.numeroPasaporte.disable();
        break;
      case this.otrosId:
        this.numeroDocumentoOtros.setValue(agendamientoExistente.paciente.numeroDocumento);
        this.numeroDocumentoOtros.disable();
        break;
    }

    this.registroPacienteDni(
      agendamientoExistente.paciente.numeroDocumento,
      agendamientoExistente.paciente.idTipoDocumento
    );

    switch (agendamientoExistente.tipoAtencion) {
      case 'PRESENCIAL':
        this.tipoAtencion.setValue('Presencial (Centro de salud)');
        this.actualizarCamposTipoConsulta('Presencial (Centro de salud)');
        break;
      case 'DOMICILIARIA':
        this.tipoAtencion.setValue('Visita Domiciliaria');
        this.direccion.setValue(
          agendamientoExistente.atencionesDomiciliarias[0].direcciones.direccionCompleta
        );
        this.direccionCompletaValue =
          agendamientoExistente.atencionesDomiciliarias[0].direcciones.direccionCompleta;
        this.actualizarCamposTipoConsulta('Visita Domiciliaria');
        break;
      case 'TELEMEDICINA':
        this.tipoAtencion.setValue('Telemedicina');
        this.link.setValue(agendamientoExistente.atencionesTelemedicina[0].link);
        this.actualizarCamposTipoConsulta('Telemedicina');
        break;
    }
  }

  getFormDataExistente() {
    this.formDataRegistroPaciente.isUpdate = false;
    const sub = this.shareDataService.getFormData().subscribe((formData) => {
      if (formData) {
        this.formDataRegistroPaciente = formData;
        this.route.params.subscribe((params) => {
          this.fromEdit = params['fromEdit'] === 'true';
          if (this.fromEdit || this.formDataRegistroPaciente.isUpdate) {
            this.formDataRegistroPaciente.isUpdate = true;
          } else if (!this.fromEdit && !this.formDataRegistroPaciente.isUpdate) {
            this.formDataRegistroPaciente.isUpdate = false;
          } else {
            this.formDataRegistroPaciente.isUpdate = false;
          }
        });
        if (!this.formDataRegistroPaciente.isUpdate && !this.fromEdit) {
          this.consultaForm.patchValue(formData); // Precargar los datos en el formulario
          this.archivosPaciente.setValue(formData.archivos || []);
          this.NoExistePaciente.set(formData.existePaciente || false);
          this.showCampoNumeroDocumento(formData.tipoDocumento);
          this.actualizarCamposTipoConsulta(formData.tipoAtencion);
          this.filterDirecciones(formData.direccionCompleta || '', true);
        }
      }
    });
    this.subs.add(sub);
  }

  public registroPacienteDni(numDoc: any, idTipoDocumento: any) {
    if (numDoc && idTipoDocumento === null) {
      return;
    }

    const medicalCenterId = this.storage.getItem<CentroMedico>(
      StorageKeys.CURRENT_MEDICAL_CENTER,
      StorageType.LOCAL
    )?.idCentroMedico as string;

    const sub = this._agendamientosService.getExistePaciente(numDoc, medicalCenterId).subscribe({
      next: (resp) => {
        this.archivosPaciente.setValue([]);
        this.resetCamposNombreApellidoEmail();
        this.setCamposRequeridos();

        const existePaciente = resp.data;

        if (!resp || !resp.data) {
          this.dataExistePaciente = null;
          this.NoExistePaciente.set(true);
          return;
        }

        const numeroDocumentoService = existePaciente.numeroDocumento;
        const idTipoDocumentoService = existePaciente.tipoDocumento.idTipoDocumento;

        const data = {
          numeroDocumento: existePaciente.numeroDocumento || numDoc,
          nombre: existePaciente.nombres || '',
          apellidos: existePaciente.apellidos || '',
          email: existePaciente.correoElectronico || '',
          numero: existePaciente.telefono || '',
          prevision: existePaciente.prevision.idPrevision || '',
        };

        if (numDoc === numeroDocumentoService && idTipoDocumento !== idTipoDocumentoService) {
          this.snackBar.openFromComponent(SnackInfoComponent, {
            data: {
              message: 'El número de documento ya existe en el sistema.',
              type: SnackInfoType.INFO,
            } as SnackInfoProps,
          });

          ['numeroDocumento', 'numeroDocumentoOtros', 'numeroPasaporte'].forEach((controlName) => {
            const control = this.consultaForm.get(controlName);
            if (control) {
              control.reset();
            }
          });

          this.NoExistePaciente.set(false);
          return;
        }

        if (numDoc === numeroDocumentoService && idTipoDocumento === idTipoDocumentoService) {
          this.dataExistePaciente = { ...data };
          this.consultaForm.patchValue(data);
          this.validarCamposDelServicio();
          this.NoExistePaciente.set(false);
          this.consultaForm.updateValueAndValidity();
          return;
        } else {
          this.NoExistePaciente.set(true);
          this.consultaForm.updateValueAndValidity();
          return;
        }
      },
    });
    this.subs.add(sub);
  }

  /* RESET CAMPOS FORMULARIO*/
  private resetCamposNombreApellidoEmail() {
    this.consultaForm.get('nombre')?.setValue(null);
    this.consultaForm.get('nombre')?.setErrors(null);
    this.consultaForm.get('nombre')?.markAsPristine();
    this.consultaForm.get('nombre')?.markAsUntouched();

    this.consultaForm.get('apellidos')?.setErrors(null);
    this.consultaForm.get('apellidos')?.setValue(null);
    this.consultaForm.get('apellidos')?.markAsPristine();
    this.consultaForm.get('apellidos')?.markAsUntouched();

    this.consultaForm.get('email')?.setValue(null);
    this.consultaForm.get('email')?.setErrors(null);
    this.consultaForm.get('email')?.markAsPristine();
    this.consultaForm.get('email')?.markAsUntouched();

    this.consultaForm.get('numero')?.setValue(null);
    this.consultaForm.get('numero')?.setErrors(null);
    this.consultaForm.get('numero')?.markAsPristine();
    this.consultaForm.get('numero')?.markAsUntouched();
  }

  private setCamposRequeridos() {
    this.consultaForm.get('nombre')?.setValidators([Validators.required]);
    this.consultaForm.get('apellidos')?.setValidators([Validators.required]);
    this.consultaForm
      .get('email')
      ?.setValidators([Validators.required, Validators.pattern(this.formatoEmail)]);
    this.consultaForm.get('numero')?.setValidators([Validators.required]);

    this.consultaForm.get('nombre')?.updateValueAndValidity();
    this.consultaForm.get('apellidos')?.updateValueAndValidity();
    this.consultaForm.get('email')?.updateValueAndValidity();
    this.consultaForm.get('numero')?.updateValueAndValidity();
  }

  private validarCamposDelServicio() {
    const camposAValidar = ['numeroDocumento', 'nombre', 'apellidos', 'email'];

    camposAValidar.forEach((campo) => {
      const control = this.consultaForm.get(campo);
      if (control) {
        control.markAsTouched();
        control.updateValueAndValidity();
      }
    });
    this.consultaForm.updateValueAndValidity();
  }

  public displayAddress(direccion: any): string {
    return direccion ? direccion : ''; // Mostramos el atributo address
  }

  public onSelectDireccion(selectedAddress: string): void {
    //se busca la direccion seleccionada en el la lista de direcciones

    const direccionSeleccionada = this.listDirecciones.find(
      (direccion) => direccion.address === selectedAddress
    );
    this.addresDireccionSeleccionada = direccionSeleccionada?.id;
    const nombreDireccion = direccionSeleccionada?.address;
    //id de la seleccion de direccion

    if (nombreDireccion) {
      this.IdDireccionSignal.setDireccionSeleccionada(nombreDireccion);
    }

    this.idDireccionSeleccionada = direccionSeleccionada?.id;
    this.consultaForm
      .get('direccion')
      ?.setValue(direccionSeleccionada?.address || selectedAddress, { emitEvent: false });
    this.lastProcessedAddress = (direccionSeleccionada?.address || selectedAddress).toLowerCase();
  }

  public filterDirecciones(direc: any, autoSelect: boolean = false): void {
    const filterValue =
      direc !== null && (typeof direc === 'string' || direc instanceof String)
        ? direc.toLocaleLowerCase()
        : '';

    if (filterValue) {
      const sub = this.buscarDireccionService.getDirecciones(filterValue).subscribe({
        next: (resp) => {
          this.listDirecciones = resp.data;
          let filter = this.listDirecciones.filter((direccion) =>
            direccion.address.toLocaleLowerCase().includes(filterValue)
          );

          this.filterDireccion = of(filter.map((direccion) => direccion.address));
          this.filteredOptionsEmptyDireccion = !Boolean(filter.length);
          this.showDireccionManual = false;

          // Si no se encontra la direccion se guardar el valor ingresado
          if (!filter.length && direc) {
            this.direccionCompletaValue = direc;
          }

          this.cdr.detectChanges();

          if (autoSelect) {
            this.onSelectDireccion(direc);
          }
        },
        error: (error) => {
          if (error.error?.error.statusCode === 500 && error.error.error.code === 'error/unknown') {
            this.direccionCompletaValue = direc;
            if (direc) {
              this.direccionCompletaValue = direc;
            }
          }
        },
      });

      this.subs.add(sub);
      this.showDireccionManual = false;
    }
  }

  /*MÉTODOS QUE MUESTRAN CAMPOS DEPENDIENTES SEGUN OPCION SELECCIONADA*/
  public showCampoNumeroDocumento(valor: any): void {
    this.numeroDocumento?.clearValidators();
    this.numeroPasaporte?.clearValidators();
    this.numeroDocumentoOtros?.clearValidators();

    this.showCamposDni = false;
    this.showCamposPassport = false;
    this.showCamposOtros = false;

    if (valor) {
      switch (valor) {
        case this.dniId:
          this.showCamposDni = true;
          this.numeroDocumento?.setValidators([
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(12),
          ]);
          break;

        case this.pasaporteId:
          this.showCamposPassport = true;
          this.numeroPasaporte?.setValidators([
            Validators.required,
            Validators.minLength(1),
            Validators.maxLength(12),
          ]);
          break;

        case this.otrosId:
          this.showCamposOtros = true;
          this.numeroDocumentoOtros?.setValidators([
            Validators.required,
            Validators.minLength(1),
            Validators.maxLength(12),
          ]);
          break;

        default:
          break;
      }

      this.numeroDocumento?.updateValueAndValidity();
      this.numeroPasaporte?.updateValueAndValidity();
      this.numeroDocumentoOtros?.updateValueAndValidity();
    }

    this.consultaForm.updateValueAndValidity();
  }

  public actualizarCamposTipoConsulta(tipoAtencion: string): void {
    this.showCamposDomicilio = false;
    this.showCampoTelMed = false;

    this.consultaForm.get('direccion')?.clearValidators();
    this.consultaForm.get('casaDepto')?.clearValidators();
    this.consultaForm.get('link')?.clearValidators();

    switch (tipoAtencion) {
      case 'Visita Domiciliaria':
        this.showCamposDomicilio = true;
        this.consultaForm.get('direccion')?.setValidators([Validators.required]);
        break;
      case 'Telemedicina':
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\/?].*)?$/i;
        this.showCampoTelMed = true;
        this.consultaForm
          .get('link')
          ?.setValidators([Validators.required, Validators.pattern(urlPattern)]);
        break;
    }

    this.consultaForm.get('direccion')?.updateValueAndValidity();
    this.consultaForm.get('casaDepto')?.updateValueAndValidity();
    this.consultaForm.get('link')?.updateValueAndValidity();

    this.consultaForm.updateValueAndValidity();
  }

  /*VALIDACIONES INPUTS*/
  public soloNumeros(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.replace(/[^0-9]/g, '');
    this.consultaForm.controls['numeroDocumento'].setValue(value);
  }

  public soloLetras(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.keyCode);
    if (!/^[a-zA-ZÑñ0-9\sáéíóúÁÉÍÓÚ]*$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  public restringirCaracteresEspeciales(event: KeyboardEvent) {
    const inputChar = event.key;
    if (!/^[a-zA-Z0-9._@-]*$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  public validateUrl(value: string): boolean {
    const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\/?].*)?$/i;
    return urlPattern.test(value);
  }

  /*Manejo de eventos campos seleccionables*/
  manejoDataDni(event: Event, controlName: string) {
    this.utilServiceService.formatDni(event);

    clearTimeout((this as any)._dniTimeout);
    (this as any)._dniTimeout = setTimeout(() => {
      if (
        this.consultaForm.get(controlName)?.valid &&
        /^\d{8,12}$/.test((event.target as HTMLInputElement).value)
      ) {
        this.manejarInputValue(event);
      }
    }, 400);
  }

  manejoDataPasaporte(event: Event, controlName: string) {
    this.utilServiceService.formatPasaporte(event);

    clearTimeout((this as any)._pasaporteTimeout);
    (this as any)._pasaporteTimeout = setTimeout(() => {
      if (
        this.consultaForm.get(controlName)?.valid &&
        /^[a-zA-Z0-9]{1,12}$/.test((event.target as HTMLInputElement).value)
      ) {
        this.manejarInputValue(event);
      }
    }, 400);
  }

  public manejarInputValue(event: Event): void {
    const input = event.target as HTMLInputElement;
    const idTipoDocumento = this.consultaForm.get('tipoDocumento')?.value;
    this.cdr.detectChanges();
    this.registroPacienteDni(input.value, idTipoDocumento);
  }

  public campoSeleccionado(event: MatSelectChange) {
    const valorSeleccionado = event.value;
    this.consultaForm.reset();
    this.consultaForm.get('tipoDocumento')?.setValue(valorSeleccionado);
    this.consultaForm.updateValueAndValidity();
    this.actualizarCamposTipoConsulta('');
    this.showCampoNumeroDocumento(valorSeleccionado);
  }

  public campoSeleccionadoPrevision(event: MatSelectChange) {
    const previsionSeleccionada = event.value;
    if (previsionSeleccionada) {
      this.consultaForm.get('prevision')?.updateValueAndValidity();
    }
  }

  public campoSeleccionadoTipoAtencion(event: MatSelectChange) {
    const atencionSeleccionada = event.value;
    this.resetCamposTipoAtencion();
    this.actualizarCamposTipoConsulta(atencionSeleccionada);
  }

  private resetCamposTipoAtencion() {
    const tipoAtencion = this.consultaForm.get('tipoAtencion')?.value;
    this.consultaForm.patchValue({
      tipoAtencion: tipoAtencion,
      institucion: '',
      link: '',
      direccion: '',
      casaDepto: '',
    });
    const fieldsToUntouch = ['tipoAtencion', 'institucion', 'link', 'direccion', 'casaDepto'];
    fieldsToUntouch.forEach((field) => {
      this.consultaForm.get(field)?.markAsUntouched();
    });
    this.consultaForm.updateValueAndValidity();
  }

  /*LOGICA PARA MOSTRAR MODAL DE DATOS MODIFICADOS*/
  public formularioModificado(): boolean {
    const valoresActuales = this.consultaForm.value;
    if (!this.dataExistePaciente) {
      return false;
    }
    return (
      valoresActuales.nombre !== this.dataExistePaciente?.nombre ||
      valoresActuales.apellidos !== this.dataExistePaciente?.apellidos ||
      valoresActuales.email !== this.dataExistePaciente?.email
    );
  }

  /*REDIRECT Y SUBMIT FORM*/
  public ingresarHoraConsulta() {
    this.formularioHora = true;
  }

  private checkAddressChange(): void {
    const direccionAnterior =
      this.agendamientoExistente?.atencionesDomiciliarias?.[0]?.direcciones?.direccionCompleta ||
      '';
    const idDireccionAnterior =
      this.agendamientoExistente?.atencionesDomiciliarias?.[0]?.direcciones?.idDireccion || '';

    const textoDireccionActual = this.consultaForm.get('direccion')?.value?.trim() || '';
    const textoDireccionCompletaActual =
      this.consultaForm.get('direccionCompleta')?.value?.trim() || '';

    const idCambio =
      this.addresDireccionSeleccionada && this.addresDireccionSeleccionada !== idDireccionAnterior;

    const textoCambiado =
      (!this.addresDireccionSeleccionada || this.addresDireccionSeleccionada === '') &&
      textoDireccionActual !== direccionAnterior &&
      textoDireccionCompletaActual !== direccionAnterior;

    const direccionModificada = idCambio || textoCambiado;

    if (direccionModificada) {
      this.consultaForm
        .get('direccionCompleta')
        ?.setValue(this.consultaForm.value['direccion'] || '');
      this.consultaForm
        .get('direccion')
        ?.setValue(this.addresDireccionSeleccionada || textoDireccionActual);
      return;
    }
    this.consultaForm.get('direccionCompleta')?.setValue(this.direccionCompletaValue);
    this.consultaForm.get('direccion')?.setValue(this.idDireccionSeleccionada);
  }

  async onSubmit() {
    this.checkAddressChange();
    const formDataRegistroPaciente: IDataPacienteForm = this.consultaForm.getRawValue();

    if (this.idAgendamientoToUpdate()) {
      formDataRegistroPaciente.isUpdate = true;
      formDataRegistroPaciente.idAgendamientoToUpdate = this.idAgendamientoToUpdate()!;
      formDataRegistroPaciente.fechaSeleccionada = this.agendamientoExistente!.fechaAtencion;
      formDataRegistroPaciente.horaSeleccionada = this.agendamientoExistente!.horaAtencion;
    }

    /* formDataRegistroPaciente.fromEdit = this.fromEdit; */

    this.shareDataService.setFormData({
      ...formDataRegistroPaciente,
      archivos: this.archivosPaciente.value || [],
      existePaciente: this.NoExistePaciente(),
    });

    if (this.formularioModificado()) {
      const dialogRef = this.dialog.open(ModalConfirmCambioDatosComponent, {
        data: { formDataRegistroPaciente },
        autoFocus: false,
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result && result.update) {
          this.router.navigate(['/hora-fecha'], {
            state: { formDataRegistroPaciente },
            queryParams: {
              fecha: this.dateSelected,
            },
          });
          this.subs.unsubscribe();
        }
      });
    } else {
      this.router.navigate(['/hora-fecha'], {
        state: { formDataRegistroPaciente },
        queryParams: {
          fecha: this.dateSelected,
        },
      });
      this.subs.unsubscribe();
    }
  }
}
